import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/withdraw.css";
class Withdraw extends Component {

  constructor(props) {
    super(props);

    this.state = {
      user: null,
      amount: ""
    };
  }

  componentDidMount() {

    let user =
      this.props.location?.state?.user;

    if (!user) {

      const stored =
        localStorage.getItem("user");

      if (stored) {
        user =
          JSON.parse(stored);
      }

    }

    if (!user) {
      this.props.navigate("/");
      return;
    }

    this.setState({
      user
    });

  }




  submitRequest = async () => {

    if (
      !this.state.amount ||
      Number(this.state.amount) <= 0
    ) {
      alert("Enter valid amount");
      return;
    }

    const res =
      await fetch("https://api.hi-bigame.online/withdraw-request",
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
               Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          body: JSON.stringify({
            userId: this.state.user.id,
            amount: this.state.amount
          })
        }
      );

    const data = await res.json();

    alert(data.message);

    if (data.success) {
      this.props.navigate("/home",
        {
          state: {
            user: this.state.user
          }
        }
      );
    }

  };


  

  render() {

    return (
      <div>

        <div className="withdraw-container">

          <div className="withdraw-card">

            <h1 className="withdraw-title">💸 Withdraw</h1>

            <input type="number" placeholder="Enter Amount" value={this.state.amount} onChange={(e) =>
              this.setState({ amount: e.target.value })} className="withdraw-input" />

            <button className="withdraw-submit" onClick={this.submitRequest}>Submit Request 🚀</button>

            <button className="withdraw-back" onClick={() => this.props.navigate("/home", {
              state: { user: this.state.user }
            })}> Back</button>

          </div>

        </div>


      </div>
    );

  }

}

export default withNavigation(Withdraw);